import React, { useContext, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { Nullable } from '@tager/web-core';

import { productContext } from '@/providers/Product';
import MultiPriceView from '@/modules/Product/components/Main/components/MultiPrice/MultiPriceView';
import { FullProductType } from '@/typings/model';

type Props = {
  product: Nullable<FullProductType>;
};

function MultiPrice({ product }: Props) {
  const [isOptionsOpen, setOpen] = useState(false);
  const [currentIndex, setIndex] = useState(0);

  const { priceHandler, optionHandler } = useContext(productContext);

  const valuesData = useMemo(() => {
    if (
      !product?.multiplePricesEnabled ||
      !product?.multiplePricesLabel ||
      !product?.multiplePricesValues?.length
    ) {
      return null;
    }
    return {
      label: product.multiplePricesLabel,
      options: product.multiplePricesValues,
      enabled: product.multiplePricesEnabled,
    };
  }, [product]);

  useEffect(() => {
    if (valuesData?.enabled && valuesData?.label) {
      optionHandler?.(valuesData.label, valuesData.options[currentIndex].name);
      priceHandler?.(
        valuesData.options[currentIndex].price,
        valuesData.options[currentIndex].discountPrice
      );
    } else {
      priceHandler?.(product?.price, product?.discountPrice);
    }
  }, [
    currentIndex,
    product?.discountPrice,
    product?.price,
    valuesData?.enabled,
    valuesData?.label,
    valuesData?.options,
  ]);

  return (
    <Component>
      <Wrapper>
        {valuesData ? (
          <MultiPriceView
            data={valuesData}
            setOpen={setOpen}
            setIndex={setIndex}
            isOptionsOpen={isOptionsOpen}
            currentIndex={currentIndex}
          />
        ) : null}
      </Wrapper>
    </Component>
  );
}

export default MultiPrice;

const Component = styled.div``;

const Wrapper = styled.div`
  margin-top: 11px;
`;
